<template>
	<div class="merge-container">
		<div class="merge-header-container" >
			<div v-if="!expanded && left != null" class="h1-buttons mb-0 col">
				<h3>Local</h3>
				<div v-if="final != left && right != null" class="d-flex" style="gap: 0.5em;">
					<button class="btn btn-secondary" title="Previous Change" @click="$refs.left.goToPrevChange()">
						&lt;
					</button>
					<button class="btn btn-secondary" title="Next Change" @click="$refs.left.goToNextChange()">
						&gt;
					</button>
				</div>
				<div class="my-2">
					<button v-if="!readonly" class="btn btn-secondary" @click="setFinalCode(left)">
						Keep Local
					</button>
				</div>
			</div>
			<div v-if="!readonly" class="h1-buttons mb-0 col">
				<h3>Merged</h3>
				<div class="my-2">
					<button @click="toggleExpanded()" class="btn btn-secondary">
						<span v-if="!expanded">Expand</span>
						<span v-if="expanded">Collapse</span>
					</button>
				</div>
			</div>
			<div v-if="!expanded" class="h1-buttons mb-0 col">
				<h3>Remote</h3>
				<div v-if="final != right && left != null" class="d-flex" style="gap: 0.5em;">
					<button class="btn btn-secondary" title="Previous Change" @click="$refs.right.goToPrevChange()">
						&lt;
					</button>
					<button class="btn btn-secondary" title="Next Change" @click="$refs.right.goToNextChange()">
						&gt;
					</button>
				</div>
				<div class="my-2">
					<button v-if="!readonly" class="btn btn-secondary" @click="setFinalCode(right)">
						Apply Remote
					</button>
				</div>
			</div>
		</div>
		<div class="merge-body-container">
			<div v-if="!expanded && left != null" class="codediff-wrapper border-right col" ref="leftScroll" @scroll="handleScroll($event)">
				<CodeDiff
					ref="left"
					:left="final"
					:right="left"
					:diffClass="readonly ? '' : 'merge'"
					@insClick="applyInsCodeChange($event)"
					@delClick="applyDelCodeChange($event)"
				></CodeDiff>
			</div>
			<div v-if="!readonly" class="codemirror-wrapper col" ref="middleScroll" @scroll="handleScroll($event)">
				<codemirror ref="myCmDialog" :value="final" :options="cmOptions" @input="applyChange($event)"></codemirror>
			</div>
			<div v-if="!expanded" class="codediff-wrapper border-left col" ref="rightScroll" @scroll="handleScroll($event)">
				<CodeDiff
					ref="right"
					:left="final"
					:right="right"
					:diffClass="readonly ? '' : 'merge'"
					@insClick="applyInsCodeChange($event)"
					@delClick="applyDelCodeChange($event)"
				></CodeDiff>
			</div>
		</div>
	</div>
</template>

<script>

import CodeDiff from './CodeDiff';
import { codemirror } from "vue-codemirror";
import "codemirror/lib/codemirror.css";
import "codemirror/mode/javascript/javascript.js";
import "codemirror/theme/eclipse.css";
import "codemirror/addon/display/autorefresh.js";
import debounce from '../../util/debounce';

export default {
	name: "GitMerge",
	components: {
		CodeDiff,
		codemirror
	},
	props: {
		left: String,
		right: String,
		final: String,
		readonly: Boolean,
		synchronousScrolling: Boolean
	},
	watch: {

	},
	data() {
		return {
			expanded: false,
			cmOptions: {
				tabSize: 4,
				mode: "text/javascript",
				theme: "eclipse",
				lineNumbers: true,
				autoRefresh: true,
				scrollbarStyle: 'null'
			}
		};
	},
	methods: {
		close() {
			this.$refs.gitMergeModal.hide();	
		},
		applyChange: debounce(function(code) {
			this.setFinalCode(code);
		}, 300),
		applyInsCodeChange(event) {
			if (this.readonly) return;

			const final = this.spliceSlice(this.final, event.pos, 0, event.value);
			this.setFinalCode(final);
		},
		applyDelCodeChange(event) {
			if (this.readonly) return;

			const final = this.spliceSlice(this.final, event.pos, event.len);
			this.setFinalCode(final);
		},
		spliceSlice(str, index, count, add) {
			return str.slice(0, index) + (add || "") + str.slice(index + count);
		},
		setFinalCode(code) {
			this.$emit('change', code);
		},
		toggleExpanded() {
			this.expanded = !this.expanded;
		},
		handleScroll(event) {
			if (!this.synchronousScrolling) return;

			const scrollLeft = event.target.scrollLeft;
			const scrollTop = event.target.scrollTop;

			if (this.$refs.leftScroll) {
				this.scrollTo(this.$refs.leftScroll, scrollLeft, scrollTop);
			}
			if (this.$refs.rightScroll) {
				this.scrollTo(this.$refs.rightScroll, scrollLeft, scrollTop);
			}
			if (this.$refs.middleScroll) {
				this.scrollTo(this.$refs.middleScroll, scrollLeft, scrollTop);
			}
		},
		scrollTo(el, scrollLeft, scrollTop) {
			el.scrollLeft = scrollLeft;
			el.scrollTop = scrollTop;
		}

	}
};
</script>

<style scoped>
button.label-btn {
	padding: .1rem;
	margin-bottom: 1.5rem;
}

.codediff-wrapper{
	padding: 0;
	height: inherit;
	width: inherit;
	overflow: auto;
}

.codemirror-wrapper{
	padding: 0;
	height: inherit;
	width: inherit;
	overflow: auto;
	background: white;
}

.merge-container {
	height: inherit;
	width: inherit;
	display: flex;
	flex-direction: column;
}

.merge-header-container {
	display: flex;
}

.merge-body-container {
	display: flex;
	height: 100%;
	width: 100%;
}

.landscape .merge-container {
	flex-direction: row;
}

.landscape .merge-header-container {
	flex-direction: column;
	flex: 0 0 8.333333%;
	max-width: 8.333333%;

}

.landscape .h1-buttons {
	flex-direction: column;
	justify-content: center;
}

.landscape .merge-body-container {
	flex-direction: column;
	flex: 0 0 91.666667%;
	max-width: 91.666667%;
}

</style>